import { Controller } from '@hotwired/stimulus';
import AutoSave from 'stimulus/auto_save';

// Hotwire counterpart of frontend/components/styleguide/radio/Radio.tsx.
//
// Exclusivity, keyboard navigation and form submission are native to
// `<input type="radio">`, so the controller only mirrors React's
// `handleChange`: persist when an auto-save url is given, then announce the
// change — the Hotwire stand-in for `onChange(event, name, value)`, which is
// how an enclosing controller reacts to the selection.
export default class extends Controller {
  static targets = ['input'];

  static values = {
    autoSaveUrl: String,
    // React passes `debounceMs: 0` — a radio click is a deliberate, final
    // choice, so it saves immediately.
    debounce: { type: Number, default: 0 }
  };

  connect() {
    this.autoSave = new AutoSave({
      url: this.autoSaveUrlValue,
      name: this.inputTarget.name,
      debounce: this.debounceValue,
      label: this.identifier
    });
  }

  disconnect() {
    this.autoSave.cancel();
  }

  // ── Public actions (wired from data-action) ────────────────────────────────
  handleChange() {
    if (this.autoSaveUrlValue) this.autoSave.save(this.inputTarget.value);

    this.dispatch('change', {
      detail: { name: this.inputTarget.name, value: this.inputTarget.value }
    });
  }
}
